<template>
    <span class="icon-wrap">
        <slot />
    </span>
</template>

<style lang="scss">
.icon-wrap {
    border-radius: 20px;
    width: 50px;
    height: 50px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: $icon-wrap-icon-bg;
    margin-inline-end: px2rem(20);
    flex-shrink: 0;

    svg {
        fill: $icon-wrap-icon-fill;
        max-width: 23px;
        max-height: 23px;
        width: 100%;
        height: 100%;
    }
}
</style>
